/**
 * Created by Ivan on 16.04.2024
 */

const StickersBook = function () {
    cleverapps.EventEmitter.call(this);

    this.load();
};

StickersBook.prototype = Object.create(cleverapps.EventEmitter.prototype);
StickersBook.prototype.constructor = StickersCollection;

StickersBook.prototype.load = function (stored) {
    const save = stored || cleverapps.dataLoader.load(DataLoader.TYPES.STICKERS_BOOK_INFO) || {};
    const saveAttention = cleverapps.dataLoader.load(DataLoader.TYPES.STICKERS_BOOK_ATTENTION) || [];

    this.version = save.version;
    this.points = save.points || 0;
    this.jokers = save.jokers || 0;

    this.createCollections(save, saveAttention);
};

StickersBook.prototype.isAvailable = function () {
    return levels.user.checkAvailable(cleverapps.config.availables.STICKERS_BOOK);
};

StickersBook.prototype.updateSeason = function () {
    if (this.isAvailable()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STICKERS_DAU);

        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.STICKERS_COLLECTIONS + this.getCompletedCollectionsAmount(), {
            key: cleverapps.EVENTS.STICKERS_COLLECTIONS
        });
    }
};

StickersBook.prototype.createCollections = function (save, saveAttention) {
    save = save || {};
    saveAttention = saveAttention || [];

    this.collections = [];

    this.collectionsAmount = this.calcCollectionsAmount();

    const info = save.collections || [];

    for (let i = 0; i < this.collectionsAmount; i++) {
        const collectionInfo = this.binaryToArray(info[i] || 0, StickersCollection.STICKERS_IN_COLLECTION + 1);
        const isPrizeCollected = Boolean(collectionInfo.pop());
        const collection = new StickersCollection({
            stickers: collectionInfo,
            isPrizeCollected,
            index: i,
            attention: this.binaryToArray(i < saveAttention.length ? saveAttention[i] : 0, StickersCollection.STICKERS_IN_COLLECTION)
        });

        collection.on("update", () => {
            this.trigger("update");
        });

        this.collections.push(collection);
    }
};

StickersBook.prototype.updateInfo = function (serverData) {
    if (!serverData) {
        return;
    }

    this.load(serverData);
    this.save(true);
};

StickersBook.prototype.updateAttention = function (data) {
    this.collections.forEach((collection, index) => {
        const info = this.binaryToArray(index < data.length ? data[index] : 0, StickersCollection.STICKERS_IN_COLLECTION);
        collection.updateAttention(info);
    });
};

StickersBook.prototype.getAvailableCollections = function () {
    const availableCollections = [];
    for (let i = 0; i < this.collections.length; i++) {
        if (this.collections[i].isAvailable()) {
            availableCollections.push(this.collections[i]);
        } else {
            break;
        }
    }

    return availableCollections;
};

StickersBook.prototype.getInfo = function () {
    const collectionsInfo = this.getAvailableCollections().map((collection) => collection.getInfo());
    return {
        collections: collectionsInfo.map((info) => {
            info.stickers.push(info.isPrizeCollected ? 1 : 0);
            return this.arrayToBinary(info.stickers);
        }),
        points: this.points,
        jokers: this.jokers,
        version: this.version
    };
};

StickersBook.prototype.getAttentionInfo = function () {
    return this.collections.map((collection) => this.arrayToBinary(collection.getAttentionInfo()));
};

StickersBook.prototype.arrayToBinary = function (array) {
    return array.reduce((acc, curr) => (acc << 1) | curr, 0);
};

StickersBook.prototype.binaryToArray = function (binary, length) {
    const array = [];
    for (let i = 0; i < length; i++) {
        array.unshift(binary & 1);
        binary >>= 1;
    }
    return array;
};

StickersBook.prototype.givePrize = function (amount, sourceEvent) {
    this.newStickers = this.newStickers || [];

    const regular = [];
    const rare = [];

    this.getAvailableCollections().forEach((collection) => {
        collection.stickers.forEach((sticker) => {
            if (sticker.rarity === StickersCollection.RARITIES[1]) {
                rare.push(sticker);
            } else {
                regular.push(sticker);
            }
        });
    });

    const disableRepeats = regular.length + rare.length >= amount;

    let duplicates = 0;

    for (let i = 0; i < amount; i++) {
        const luck = Math.random();
        let sticker;
        if (luck <= 0.1) {
            sticker = PseudoRandom.GET().choose(rare);
            disableRepeats && rare.splice(rare.indexOf(sticker), 1);
        } else {
            sticker = PseudoRandom.GET().choose(regular);
            disableRepeats && regular.splice(regular.indexOf(sticker), 1);
        }
        if (sticker.getState() === Sticker.STATE_OPENED) {
            this.incPoints(sticker.rarity === StickersCollection.RARITIES[1] ? StickersCollection.RARE_POINTS : StickersCollection.REGULAR_POINTS);
            sticker.duplicate = true;
            duplicates++;
        } else {
            sticker.open(sourceEvent);
        }
        this.newStickers.push(sticker);
    }

    if (duplicates > 0) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STICKER_DUPLICATE + sourceEvent, { value: duplicates });
    }

    this.newStickers = this.newStickers.sort((a, b) => b.isRare() - a.isRare());
};

StickersBook.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.STICKERS_BOOK_INFO, this.getInfo());
    if (!fromServer) {
        connector.synchronizer.addSendTask("stickersbook");
    }

    cleverapps.dataLoader.save(DataLoader.TYPES.STICKERS_BOOK_ATTENTION, this.getAttentionInfo());
};

StickersBook.prototype.getOpenedStickersAmount = function () {
    let amount = 0;
    this.getAvailableCollections().forEach((collection) => {
        amount += collection.getOpenedStickersAmount();
    });
    return amount;
};

StickersBook.prototype.getCompletedCollectionsAmount = function () {
    return this.collections.filter((collection) => collection.isCompleted).length;
};

StickersBook.prototype.isCompleted = function () {
    return this.collections.filter((collection) => collection.isCollected()).length === this.collectionsAmount;
};

StickersBook.prototype.exchangePointsToJokers = function () {
    const jokers = Math.floor(this.points / StickersCollection.GOAL_POINTS);
    this.points -= jokers * StickersCollection.GOAL_POINTS;
    this.trigger("updatePoints");
    return jokers;
};

StickersBook.prototype.addJokers = function (amount) {
    amount = amount || 1;
    this.jokers += amount;
    this.trigger("updateJokersAmount", this.jokers);
    this.save();
};

StickersBook.prototype.isFullPoints = function () {
    return this.points >= StickersCollection.GOAL_POINTS;
};

StickersBook.prototype.incPoints = function (amount) {
    this.points += amount;
    this.trigger("updatePoints");
    this.save();
};

StickersBook.prototype.useJoker = function () {
    this.jokers--;
    this.trigger("updateJokersAmount", this.jokers);
    this.save();
};

StickersBook.prototype.hasAttention = function () {
    return this.collections.filter((collection) => collection.hasAttention()).length;
};

StickersBook.isPuzzle = function () {
    return ["wooden"].includes(cleverapps.config.ui);
};

StickersBook.getCollectionReward = function (collectionIndex) {
    return RewardsConfig.StickersBook[collectionIndex % RewardsConfig.StickersBook.length];
};

StickersBook.prototype.calcCollectionsAmount = function () {
    let collectionsAmount = 0;
    while (bundles[StickersCollection.getCollectionBundle(collectionsAmount, this.season)]) {
        collectionsAmount++;
    }

    return collectionsAmount;
};

StickersBook.prototype.getLevelReward = function () {
    const StickersBookLevelRewards = {
        "hard": 3,
        "default": 1
    };
    return Game.currentGame.getNormalizedLevelReward(StickersBookLevelRewards, "match3");
};

StickersBook.prototype.collectionBundle = function (collectionIndex) {
    return StickersCollection.getCollectionBundle(collectionIndex);
};

StickersBook.PRODUCTS = ["stickers2", "stickers1", "stickers0"];

cleverapps.InitByFeature["stickers_book"] = function () {
    cleverapps.stickersBook = new StickersBook();

    if (cleverapps.toolModel) {
        ToolModel.AUTONAVIGATE.push({
            windows: [StickersBookWindow],
            path: ["stickersBook"]
        });
    }
};